import { useTranslation } from "react-i18next";
import Button from "../components/common/Button";

export default function VideoPosterModal({
  open,
  loading,
  frames,
  selectedIndex,
  onSelect,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  if (!open) return null;

  const selected = frames[selectedIndex];

  return (
    <div className="fixed inset-0 bg-black-900 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-4 w-full max-w-[520px] max-h-full overflow-y-auto shadow-xl">
        <h3 className="text-lg font-bold mb-1">{t("video.poster.title")}</h3>
        <p className="text-black-600 mb-4">{t("video.poster.description")}</p>

        {loading || !selected ? (
          <div className="flex flex-col items-center justify-center gap-3 py-12 text-black-600">
            <div className="w-6 h-6 border-2 border-primary-400 border-t-transparent rounded-full animate-spin" />
            <span>{t("video.poster.preparing")}</span>
          </div>
        ) : (
          <>
            <img
              src={selected.url}
              alt={t("video.poster.frame", { n: selectedIndex + 1 })}
              className="w-full max-h-[320px] object-contain rounded-lg bg-black-20 mb-3"
            />
            <div className="flex gap-2 overflow-x-auto pb-1 mb-4">
              {frames.map((frame, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => onSelect(idx)}
                  className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-3 transition-all ${
                    idx === selectedIndex ? "border-primary-400" : "border-gray-200 hover:border-primary-300"
                  }`}
                >
                  <img
                    src={frame.url}
                    alt={t("video.poster.frame", { n: idx + 1 })}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </>
        )}

        <div className="flex flex-col sm:flex-row justify-end gap-3 text-sm sm:text-lg font-bold">
          <Button variant="ghost" onClick={onCancel} className="w-full sm:w-auto">
            {t("buttons.cancel")}
          </Button>
          <Button
            variant="dark"
            onClick={onConfirm}
            disabled={loading || !selected}
            className="w-full sm:w-auto"
          >
            {t("video.poster.confirm")}
          </Button>
        </div>
      </div>
    </div>
  );
}